<template>
  <div>
    <Modal v-model="isShow" width="850" @on-ok="ok" @on-cancel="cancel" :loading="loading" :mask-closable="false">
      <h3 slot="header" class="modal-header">添加业主</h3>
      <Form :label-width="120" ref="formData" :rules="formRules" :model="formData" :inline="true">
        <FormItem label="业主类型" prop="ownerType" >
          <Select class="width100" v-model="formData.ownerType" @on-change="typeChange">
            <Option v-for="item in ownerTypeList" :value="item.value" :key="'ownertype'+item.value">{{item.text}}</Option>
          </Select>
        </FormItem>
        <FormItem label="业主名称" prop="ownerName">
          <Input class="width150" v-model="formData.ownerName"/>
        </FormItem>
        <FormItem label="经办人" prop="ownerOperatorName">
          <Input class="width150" v-model="formData.ownerOperatorName"/>
        </FormItem>
        <br>

        <div v-if="formData.ownerType==1" >
          <FormItem label="法定代表人" prop="ownerLegalRepresent">
            <Input class="width100" v-model="formData.ownerLegalRepresent"/>
          </FormItem>
          <FormItem label="组织机构代码" prop="ownerBusinessCode">
            <Input class="width150" v-model="formData.ownerBusinessCode"/>
          </FormItem>
          <FormItem label="法人身份证号" prop="ownerOperatorIdcard">
            <Input class="width150" v-model="formData.ownerOperatorIdcard"/>
          </FormItem>
        </div>
        <div v-if="formData.ownerType==2">
          <FormItem label="产权人" prop="propertyer">
            <Input class="width100" v-model="formData.propertyer"/>
            <!--<Input class="width100" v-model="formData.propertyer"/>-->
          </FormItem>
          <FormItem label="业主身份证号" prop="ownerIdcard">
            <Input class="width150" v-model="formData.ownerIdcard"/>
          </FormItem>

          <FormItem label="产权人身份证号" prop="propertyerIdcard">
            <Input class="width150" v-model="formData.propertyerIdcard"/>
          </FormItem>
        </div>
        <FormItem label="业主联系人" prop="ownerUser">
          <Input class="width100" v-model="formData.ownerUser"/>
        </FormItem>
        <FormItem label="业主联系电话" prop="ownerPhone">
          <Input class="width150" v-model="formData.ownerPhone"/>
        </FormItem>

        <FormItem label="开户银行" prop="ownerBankName">
          <Input class="width150" v-model="formData.ownerBankName"/>
        </FormItem>
        <br>
        <FormItem label="财务联系人" prop="financeUser">
          <Input class="width100" v-model="formData.financeUser"/>
        </FormItem>
        <FormItem label="财务联系电话" prop="financePhone">
          <Input class="width150" v-model="formData.financePhone"/>
        </FormItem>
        <FormItem label="银行账号" prop="ownerBankCard">
          <Input class="width150" v-model="formData.ownerBankCard"/>
        </FormItem>
        <br>
        <FormItem label="组织机构代码附件" v-if="formData.ownerType==1">
          <Upload
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess0"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :on-error="handleError"
          >
            <Button type="ghost" icon="ios-cloud-upload-outline">选择文件</Button>
          </Upload>
          <div v-for="(item,index) in formData.attachmentBusinessUrl" :key="'keyA'+index">
            <span>{{item.attachmentName}}</span>
            <a href="javascript:;" @click.stop="deleteImg('attachmentBusinessUrl',index)">删除</a>
          </div>
        </FormItem>

        <FormItem label="产权证附件">
          <Upload
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess1"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :on-error="handleError"

          >
            <Button type="ghost" icon="ios-cloud-upload-outline">选择文件</Button>
          </Upload>
          <div v-for="(item,index) in formData.propertyImageUrl" :key="'keyB'+index">
            <span>{{item.attachmentName}}</span>
            <a href="javascript:;" @click.stop="deleteImg('propertyImageUrl',index)">删除</a>
          </div>
        </FormItem>
        <FormItem label="其他附件">
          <Upload
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess2"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :on-error="handleError"
          >
            <Button type="ghost" icon="ios-cloud-upload-outline">选择文件</Button>
          </Upload>
          <div v-for="(item,index) in formData.otherAttachments" :key="'keyC'+index">
            <span>{{item.attachmentName}}</span>
            <a href="javascript:;" @click.stop="deleteImg('otherAttachments',index)">删除</a>
          </div>
          <!--<Input class="width150"/>-->
        </FormItem>

        <br>
        <FormItem label="收房合同号" prop="ownerHouseContract">
          <Input class="width200" v-model="formData.ownerHouseContract" placeholder="多个收房合同号请用逗号隔开"/>
        </FormItem>
        <br>
        <FormItem label="备注">
          <Input class="width200" v-model="formData.remark"/>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>
<script>
  import {ownersave} from "../../../../api/owner";
  import {getBaseUrl} from "../../../../utils/public";
  import {getToken} from "../../../../utils/auth";

  export default {
    // name: "ProAdd"
    props: {
      n: {
        type: Number,
        default: 0
      }
    },
    watch: {
      n() {
        this.formData= {
          "attachmentBusinessUrl": [],
          "financePhone": "",
          "financeUser": "",
          "otherAttachments": [],
          "ownerBankCard": "",
          "ownerBankName": "",
          "ownerBusinessCode": "",
          "ownerHouseContract": "",
          "ownerIdcard": "",
          "ownerLegalRepresent": "",
          "ownerName": "",
          "ownerOperatorIdcard": "",
          "ownerOperatorName": "",
          "ownerPhone": "",
          "ownerType": 1,
          "ownerUser": "",
          "propertyImageUrl": [],
          "propertyers": [
            {
              "propertyer": "",
              "propertyerIdcard": "",
            }
          ],
          "remark": "",
          propertyer:'',
          propertyerIdcard:''
        },
        this.$refs['formData']&& this.$refs['formData'].resetFields()

        this.isShow = true
      }

    },
    data() {
      return {
        loading:true,
        token:'',
        baseUrl:'',
        ownerTypeList:[{text:'企业',value:1},{text:'个人',value:2}],
        formData: {
          "attachmentBusinessUrl": [],
          "financePhone": "",
          "financeUser": "",
          "otherAttachments": [],
          "ownerBankCard": "",
          "ownerBankName": "",
          "ownerBusinessCode": "",
          "ownerHouseContract": "",
          "ownerIdcard": "",
          "ownerLegalRepresent": "",
          "ownerName": "",
          "ownerOperatorIdcard": "",
          "ownerOperatorName": "",
          "ownerPhone": "",
          "ownerType": 1,
          "ownerUser": "",
          "propertyImageUrl": [],
          "propertyers": [
            {
              "propertyer": "",
              "propertyerIdcard": "",
            }
          ],
          "remark": "",
          propertyer:'',
          propertyerIdcard:''
        },
        formRules: {
          "propertyer":[
            {required: true, message: '请输入产权人', trigger: 'blur', type: 'string'}
          ],
          "propertyerIdcard":[
            {required: true, message: '请输入产权人身份证号', trigger: 'blur', type: 'string'}
          ],
          "financePhone":[
            {required: true, validator: this.validatecontactPhone2, trigger: 'blur', message: '请填写正确的手机号'}
          ],
          "financeUser":  [
            {required: true, message: '请输入财务联系人', trigger: 'blur', type: 'string'}
          ],
          "ownerBankCard":   [
            {required: true, message: '请输入银行账号', trigger: 'blur', validator:this.validateNumber}
          ],
          "ownerBankName":   [
            {required: true, message: '请输入开户银行', trigger: 'blur', type: 'string'}
          ],
          "ownerBusinessCode":   [
            {required: true, message: '请输入组织机构代码', trigger: 'blur', type: 'string'}
          ],
          "ownerHouseContract":   [
            {required: true, message: '请输入收房合同号', trigger: 'blur', type: 'string'}
          ],
          "ownerIdcard":   [
            {required: true, message: '请输入业主身份证号', trigger: 'blur', type: 'string'}
          ],
          "ownerLegalRepresent":   [
            {required: true, message: '请输入法定代表人', trigger: 'blur', type: 'string'}
          ],
          "ownerName": [
            {required: true, message: '请输入业主名称', trigger: 'blur', type: 'string'}
          ],
          "ownerOperatorIdcard": [
            {required: true, message: '请输入法人身份证号', trigger: 'blur', type: 'string'}
          ],
          // "ownerOperatorName": "string",
          "ownerPhone": [
            {required: true, message: '输入正确的联系方式', trigger: 'blur', validator: this.validatecontactPhone,}
          ],
          "ownerType":[
            {required: true, message: '请选择业主类型', trigger: 'change', validator:this.validateNumber}
          ],
          "ownerUser": [
            {required: true, message: '请输入业主联系人', trigger: 'blur', type: 'string'}
          ],
        },
        isShow: false
      }
    },
    methods: {
      typeChange(value){
        this.$refs['formData']&& this.$refs['formData'].resetFields()
        this.formData.ownerType=value
      },
      validateNumber(rule, value, callback) {
        let pattern = /^\d+$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      deleteImg(value,index){
        this.$Modal.confirm({
          content:'<p>确认删除？</p>',
          onOk:()=>{
            this.formData[value].splice(index,1)
          }
        })
      },
      handleError(){
        this.$Message.info('上传文件失败')
      },
      handleSuccess0(response,file){
        this.formData.attachmentBusinessUrl.push({
          attachmentType:0,
          "attachmentImgUrl": response.data.url,
          "fid": response.data.fid,
          attachmentName:file.name
        })

      },
      handleSuccess1(response,file){
        this.formData.propertyImageUrl.push({
          attachmentType:1,
          "attachmentImgUrl": response.data.url,
          "fid": response.data.fid,
          attachmentName:file.name
        })

      },
      handleSuccess2(response,file){
        this.formData.otherAttachments.push({
          attachmentType:2,
          "attachmentImgUrl": response.data.url,
          "fid": response.data.fid,
          attachmentName:file.name
        })
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      validatecontactPhone(rule, value, callback) {
        let pattern = /^\d{10,12}$/
        if (!pattern.test(value)) {
          callback(new Error('输入正确的联系方式'));
        }
        callback();
      },
      validatecontactPhone2(rule, value, callback) {
        let pattern = /^1\d{10}$/
        if (!pattern.test(value)) {
          callback(new Error('输入正确的手机号'));
        }
        callback();
      },
      ok() {
        this.$refs['formData'].validate(bool => {
          if (bool) {
            if(this.formData.propertyer && this.formData.propertyerIdcard){
              this.formData.propertyers[0].propertyer=this.formData.propertyer
              this.formData.propertyers[0].propertyerIdcard=this.formData.propertyerIdcard
            }

            let params={
              TOwnerDto:this.formData
            }
            ownersave(this.formData).then(res=>{
              this.$Message.success('业主信息保存成功')
              this.isShow = false
              this.$emit('addsuccess')
            }).catch(error=>{
              this.changeLoading()
            })
          }
          else {
            // this.$Message.info('请检查填写内容！')
            this.changeLoading()
          }
        })
      },
      cancel() {
      }
    },
    created(){
      this.baseUrl=getBaseUrl()
      this.token=getToken()

    }
  }
</script>

<style scoped>
  .width100 {
    width: 100px;
  }
  .width200 {
    width: 400px;
  }
  .width150 {
    width: 150px;
  }

</style>
